export default "<p>specialist-medical-appointment-detail works!</p>\n"